import {
  PixelAppInstructionsQuery,
  PixelAppInstructionsQueryVariables
} from './__generated__/PixelAppInstructionsQuery';
import { kmsClient } from 'api';
import { PixelAppsQuery, PixelAppsQueryVariables } from './__generated__/PixelAppsQuery';
import { useQuery } from '@apollo/react-hooks';
import { PIXEL_TRACKING_APP_INSTRUCTIONS_QUERY, PIXEL_TRACKING_APPS_QUERY } from './pixelTrackingApps.query';

export const usePixelTrackingQuery = (variables: PixelAppsQueryVariables) =>
  useQuery<PixelAppsQuery, PixelAppsQueryVariables>(PIXEL_TRACKING_APPS_QUERY, {
    client: kmsClient,
    variables,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });

export const PixelInstructionsQuery = (variables: PixelAppInstructionsQueryVariables) => {
  return kmsClient.query<PixelAppInstructionsQuery, PixelAppInstructionsQueryVariables>({
    query: PIXEL_TRACKING_APP_INSTRUCTIONS_QUERY,
    variables,
    fetchPolicy: 'network-only'
  });
};
